import React from 'react';
import { Box } from '@mui/material';
import { COLORS, getActiveColor } from '../../pages/app/reports/groups-teams-activity/constants';

interface StatusDotProps {
    percent?: number;
    color?: string;
    isDefault?: boolean;
    size?: number;
}

export const StatusDot: React.FC<StatusDotProps> = ({ percent, color, isDefault, size = 8 }) => {
    let dotColor: string;

    if (isDefault) {
        dotColor = COLORS.border;
    } else if (color) {
        dotColor = color;
    } else if (percent !== undefined) {
        dotColor = getActiveColor(percent);
    } else {
        dotColor = COLORS.gray;
    }

    return (
        <Box
            sx={{
                width: `${size}px`,
                height: `${size}px`,
                borderRadius: '50%',
                backgroundColor: dotColor,
                flexShrink: 0,
            }}
        />
    );
};
